'use client';
import React from 'react';
import Link from 'next/link';
import Button from '@/components/primitives/button';
import styles from './styles.module.scss';

/**
 * 로그인이 필요한 경우 표시되는 모달 컨텐츠 컴포넌트
 */
const LoginRequiredModal: React.FC = () => {
  return (
    <div className={styles.root}>
      <div style={{ marginBottom: '16px', textAlign: 'center' }}>
        <p style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '500' }}>
          LoNe 에서 특별한 경험을 누려보세요!
        </p>
        <p style={{ fontSize: '14px', color: 'var(--color-gray-700)' }}>
          지금 로그인하고 더 많은 순간들을 공유해보세요.
        </p>
      </div>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
        <Link href="/auth/sign-in">
          <Button variant="secondary">로그인</Button>
        </Link>
        <Link href="/auth/sign-up">
          <Button>회원가입</Button>
        </Link>
      </div>
    </div>
  );
};

export default LoginRequiredModal;